import { X } from "lucide-react";
import { useEffect, useState } from "react";
import axios from "axios";
import { PROFILE_API } from "../../data/api";
import { useThemeAPI } from "../../context/ThemeContextAPI";

export const SettingsPanelContent = ({ closePanel }) => {
  const [activeTab, setActiveTab] = useState("users");
  const [users, setUsers] = useState([]);
  const [sellers, setSellers] = useState([]);
  const [loading, setLoading] = useState(true);
const { updateTheme } = useThemeAPI();
const handleThemeChange = (newValue) => {
  updateTheme(newValue);
};
  const loadProfiles = async () => {
    setLoading(true);
    try {
      const res = await axios.get(PROFILE_API.GET_ALL);
      console.log("Loaded Profiles:", res.data);

      const customers = res.data.filter(u => u.type === "Customer");
      const vendors = res.data.filter(u => u.type === "Vendor");

      setUsers(customers);
      setSellers(vendors);
    } catch (err) {
      console.log("Profile Load Error:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadProfiles();
  }, []);

  const handleBlock = async (item) => {
    try {
      if (item.status === "Blocked") {
        await axios.put(PROFILE_API.UNBLOCK(item.userId));
      } else {
        await axios.put(PROFILE_API.BLOCK(item.userId));
      }
      loadProfiles();
    } catch (err) {
      console.log("Block/Unblock Error:", err);
    }
  };


  const verifyItem = async (item) => {
    try {
      await axios.put(PROFILE_API.VERIFY(item.userId));
      loadProfiles();
    } catch (err) {
      console.log("Verify Error:", err);
    }
  };
  const deleteItem = async (item) => {
    if (!window.confirm("Are you sure you want to delete this user?")) return;

    try {
      await axios.delete(PROFILE_API.GET_BY_ID(item.userId));
      loadProfiles();
    } catch (err) {
      console.log("Delete Error:", err);
    }
  };

  const activeList = activeTab === "users" ? users : sellers;

  if (loading) return <p className="p-6">Loading profiles...</p>;

  return (
<div className="w-full min-h-screen bg-gradient-to-br from-gray-50 to-gray-100">
  <div className="max-w-7xl mx-auto px-6 py-8">

    {/* Header */}
    <div className="flex items-center justify-between mb-8">
      <div>
        <h2 className="text-3xl font-bold text-gray-800 tracking-tight">
          Admin Settings
        </h2>
        <p className="text-gray-500 mt-1">
          Manage customers & vendors access
        </p>
      </div>

      <button
        onClick={closePanel}
        className="p-2 rounded-full hover:bg-gray-200 transition"
      >
        {/* <X size={22} className="text-gray-600" /> */}
      </button>
    </div>

    {/* Tabs */}
    <div className="flex gap-4 mb-6">
      {["users", "sellers"].map((tab) => (
        <button
          key={tab}
          onClick={() => setActiveTab(tab)}
          className={`px-5 py-2 rounded-full text-sm font-semibold transition
            ${
              activeTab === tab
                ? "bg-blue-600 text-white shadow-md"
                : "bg-white text-gray-700 border hover:bg-gray-50"
            }`}
        >
          {tab === "users" ? "Customers" : "Vendors"}
        </button>
      ))}
    </div>

    {/* Table Card */}
    <div className="bg-white rounded-2xl shadow-lg overflow-hidden">

      <table className="w-full text-sm">
        <thead className="bg-gray-100 text-gray-600">
          <tr>
            <th className="px-6 py-4 text-left font-semibold">Name</th>
            <th className="px-6 py-4 text-left font-semibold">Email</th>
            <th className="px-6 py-4 text-left font-semibold">Status</th>
            <th className="px-6 py-4 text-left font-semibold">Verification</th>
            <th className="px-6 py-4 text-center font-semibold">Actions</th>
          </tr>
        </thead>

        <tbody>
          {activeList.map((item) => (
            <tr
              key={item.userId}
              className="border-t hover:bg-gray-50 transition"
            >
              <td className="px-6 py-4 font-medium text-gray-800">
                {item.fullName}
              </td>

              <td className="px-6 py-4 text-gray-600">
                {item.email}
              </td>

              {/* Status */}
              <td className="px-6 py-4">
                <span
                  className={`px-3 py-1 rounded-full text-xs font-semibold
                    ${
                      item.status === "Active"
                        ? "bg-green-100 text-green-700"
                        : "bg-red-100 text-red-700"
                    }`}
                >
                  {item.status}
                </span>
              </td>

              {/* Verified */}
              <td className="px-6 py-4">
                {item.verified ? (
                  <span className="px-3 py-1 rounded-full text-xs bg-blue-100 text-blue-700 font-semibold">
                    Verified
                  </span>
                ) : (
                  <span className="px-3 py-1 rounded-full text-xs bg-gray-200 text-gray-600 font-semibold">
                    Not Verified
                  </span>
                )}
              </td>

              {/* Actions */}
              <td className="px-6 py-4">
                <div className="flex justify-center gap-2">
                  <button
                    onClick={() => handleBlock(item)}
                    className={`px-3 py-1.5 rounded-lg text-xs font-semibold transition
                      ${
                        item.status === "Blocked"
                          ? "bg-green-100 text-green-700 hover:bg-green-200"
                          : "bg-red-100 text-red-700 hover:bg-red-200"
                      }`}
                  >
                    {item.status === "Blocked" ? "Unblock" : "Block"}
                  </button>

                  {!item.verified && (
                    <button
                      onClick={() => verifyItem(item)}
                      className="px-3 py-1.5 rounded-lg text-xs font-semibold bg-blue-100 text-blue-700 hover:bg-blue-200 transition"
                    >
                      Verify
                    </button>
                  )}

                  <button
                    onClick={() => deleteItem(item)}
                    className="px-3 py-1.5 rounded-lg text-xs font-semibold bg-gray-200 text-gray-700 hover:bg-gray-300 transition"
                  >
                    Delete
                  </button>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

    </div>
  </div>
</div>

  );
};

export default SettingsPanelContent;
